import React, { useEffect, useState } from "react";
import "./OurTeam.css";
import DOMPurify from 'dompurify';
import publicAxios from "../../utils/axios/publicAxios";
import { Circles } from "react-loader-spinner";
import IMAGEALT from '../../assets/images/igboezenorthlga.png';
import { memberCategories } from '../../assets/exports.js';

const OurTeam = () => {

    const [ourTeam, setOurTeam] = useState([]);
    const [loading, setLoading] = useState(false);

    const embedYouTubeLinks = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const anchors = doc.querySelectorAll('a[href*="youtube.com/watch"], a[href*="youtu.be/"]');

        anchors.forEach((a) => {
            let videoId = null;
            const url = new URL(a.href);

            if (url.hostname.includes('youtu.be')) {
                videoId = url.pathname.slice(1);
            } else {
                videoId = url.searchParams.get('v');
            }

            if (videoId) {
                const iframe = document.createElement('iframe');
                iframe.width = '100%';
                iframe.height = '400';
                iframe.src = `https://www.youtube.com/embed/${videoId}`;
                iframe.frameBorder = '0';
                iframe.allow =
                    'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
                iframe.allowFullscreen = true;

                a.replaceWith(iframe);
            }
        });

        return doc.body.innerHTML;
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        const fetchOurTeam = async () => {
            try {
                setLoading(true);
                const response = await publicAxios.get("/public/fetch-our-team");
                if (response.status === 200) {
                    const teamData = response.data.ourTeam || [];

                    // Sort the data according to the memberCategories order
                    const sortedTeam = [...teamData].sort((a, b) => {
                        const indexA = memberCategories.indexOf(a.category);
                        const indexB = memberCategories.indexOf(b.category);

                        // If both categories are in the array, sort by their index
                        if (indexA !== -1 && indexB !== -1) return indexA - indexB;

                        // If only one is in the array, that one comes first
                        if (indexA !== -1) return -1;
                        if (indexB !== -1) return 1;

                        // Otherwise keep their original order
                        return 0;
                    });

                    setOurTeam(sortedTeam);
                }
            } catch (error) {
                console.error("Error fetching team info:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchOurTeam();
    }, []);

    return (
        <div className="our-team">
            <div className='our-team-main-title'><h2>Our Team</h2></div>
            {
                loading ?
                    <div style={{ display: 'flex', flexDirection: 'column', columnGap: '10px', alignItems: 'center', justifyContent: 'center', height: '300px', color: 'gray' }}>
                        <Circles height="50" width="50" color="#008751" ariaLabel="loading" /> <h3>Loading Our Team...</h3>
                    </div> :
                    ourTeam.length ?
                        ourTeam.map((item, index) => (
                            <div className="our-team-content" key={item._id || index}>
                                {/* Left Side: Image */}
                                <div className="our-team-image-wrapper">
                                    {item.imageUrl ?
                                        <img src={item.imageUrl} alt={item.title} className="our-team-image" loading="lazy" /> :
                                        <div>
                                            <img src={IMAGEALT} alt={item.title} className="our-team-image" loading='lazy' />
                                        </div>}
                                </div>

                                {/* Right Side: Text */}
                                <div className="our-team-text" key={item._id || index}>
                                    <div >
                                        <h6 className="our-team-title">{item.title}</h6>
                                        <p style={{ fontWeight: 'bold', fontStyle: 'italic', color: 'gray', marginBottom: '10px', alignSelf: 'flex-start' }}>{item.category === 'Uncategorized' ? "" : `${item.category}`}</p>
                                    </div>
                                    <div className="post-content"
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(embedYouTubeLinks(item.content), {
                                                ADD_TAGS: ['iframe'],
                                                ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'src', 'width', 'height'],
                                            }),
                                        }}
                                    ></div>

                                </div>
                            </div>
                        )) :
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><p>No information to display</p></div>
            }
        </div>
    );
};

export default OurTeam;